const auth = {
  state: {
    password: {},
    permission: {
      id: 1,
      name: "visitor",
      localSet: "AvAiAsAiAtAoArA",
    }, // 默认权限
  },
  mutations: {
    SET_PASSWORD(state, password) {
      state.password = password;
    },

    SET_PERMISSION(state, permission) {
      state.permission = permission;
    },
  },
  actions: {
    ADD_PASSWORD(content, password) {
      let localPassword = JSON.parse(localStorage.getItem("password"));
      if (
        !localPassword ||
        localPassword === null ||
        localPassword === undefined
      ) {
        content.commit("SET_PASSWORD", password);
        localStorage.setItem("password", JSON.stringify(password));
      }
    },

    ADD_PERMISSION(content, permission) {
      content.commit("SET_PERMISSION", permission);
      localStorage.setItem("permission", permission.localSet);
    },
  },
  getters: {},
};

export default auth;
